import React from 'react'
import styled from 'styled-components'
import { useWebsiteContext } from '../context/website_context'
import { MDBSpinner, MDBBtn } from 'mdb-react-ui-kit';
import parse from 'html-react-parser';
import {Error} from '../components'
import OpacityAnimation from '../components/OpacityAnimation'


import { MDBContainer, MDBRow, MDBCol } from 'mdb-react-ui-kit'

const PublicationsPage = () => {

  const { publications, publications_loading:loading, publications_error:error } = useWebsiteContext();
  const totalPubs = publications.length;
  //console.log(totalPubs);

  //::: if is loading show the Loading component
  if(loading) {
    return (
        <div className="spinner-container">
          <MDBSpinner color='info'>
            <span className='visually-hidden'>Loading...</span>
          </MDBSpinner>
        </div>
    )
   };

  //::: if theres is an error show the Error component
  if(error) {
    return <Error />
  };



  return (
    <Wrapper>
      <OpacityAnimation>
          <MDBContainer fluid>
              <MDBRow className="publications-item__main-container mx-4">
              {
                
                publications.map( (publication) => {
                  const {id, title, pubName, date, image, linkURL, text} = publication;
                  
                  return (
                      <MDBCol key={id} md="12" lg={totalPubs > 2 ? "4": "6"} className="d-flex flex-column px-0 px-md-5 py-1 py-md-5 mb-5">
                          <h4>{title}</h4>
                          <div className="d-flex flex-row justify-content-between">
                            <p>{pubName}</p>
                            <em>{date}</em>
                          </div>
                          <hr />
                          <img src={image} className="img-fluid my-4" alt="psychiatrist-talking-to-children" />
                          <div className="publications-text__container my-4 flex-grow-1">
                            {parse(text)}
                          </div>
                          <div className="text-center flex-grow-1">
                            <MDBBtn rounded className="main-btn w-50 py-2 mb-4" onClick={()=> {window.open(`${linkURL}`)}} target='_blank' rel="noreferrer">ler mais</MDBBtn>
                          </div> 
                          <hr />
                      </MDBCol>
                  )
                }).reverse() 
              }
            </MDBRow>
          </MDBContainer>
      </OpacityAnimation>
    </Wrapper>
  )
}
const Wrapper = styled.section`
      min-height: 80vh;
      margin-top: 8rem;
      margin-bottom: 5rem;
      background-color: var(--clr-grey-10);

      .spinner-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80vh;
      }
      .spinner-border {
        width: 8rem;
        height: 8rem;
      }
      .publications-text__container {
        font-size: 1.2rem;
      }

      @media (max-width: 992px) {
        .publications-item__main-container {
          flex-direction: column;
        }
    }
      
`

export default PublicationsPage